import { render, staticRenderFns } from "./live_new.vue?vue&type=template&id=012e1d7d&scoped=true&"
import script from "./live_new.vue?vue&type=script&lang=js&"
export * from "./live_new.vue?vue&type=script&lang=js&"
import style0 from "./live_new.vue?vue&type=style&index=0&id=012e1d7d&lang=scss&scoped=true&"
import style1 from "./live_new.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012e1d7d",
  null
  
)

export default component.exports